import { PagebuilderMaxContentWidthOptions } from 'cms/constants/pagebuilder'

import { spacingUnits, theme } from 'shared/ui/utils/designTokens'

import { PagebuilderSectionSettings } from './types'

/**
 * Shared default settings.
 */
const defaultMarginSettings: Partial<PagebuilderSectionSettings> = {
  spacingDesktopMarginTop: false,
  spacingDesktopMarginTopValue: spacingUnits[40],
  spacingDesktopMarginBottom: true,
  spacingDesktopMarginBottomValue: spacingUnits[40],
  spacingTabletMarginTop: false,
  spacingTabletMarginTopValue: spacingUnits[32],
  spacingTabletMarginBottom: true,
  spacingTabletMarginBottomValue: spacingUnits[32],
  spacingMobileMarginTop: false,
  spacingMobileMarginTopValue: spacingUnits[20],
  spacingMobileMarginBottom: true,
  spacingMobileMarginBottomValue: spacingUnits[20]
}

const defaultPaddingSettings: Partial<PagebuilderSectionSettings> = {
  spacingDesktopPaddingLeft: theme.dimensions.mainXPadding,
  spacingDesktopPaddingRight: theme.dimensions.mainXPadding,
  spacingDesktopPaddingTop: spacingUnits[20],
  spacingDesktopPaddingBottom: spacingUnits[20],
  spacingTabletPaddingLeft: theme.dimensions.mainXPaddingMobile,
  spacingTabletPaddingRight: theme.dimensions.mainXPaddingMobile,
  spacingTabletPaddingTop: spacingUnits[16],
  spacingTabletPaddingBottom: spacingUnits[16],
  spacingMobilePaddingLeft: theme.dimensions.mainXPaddingMobile,
  spacingMobilePaddingRight: theme.dimensions.mainXPaddingMobile,
  spacingMobilePaddingTop: spacingUnits[12],
  spacingMobilePaddingBottom: spacingUnits[12]
}

const defaultColorSettings: Partial<PagebuilderSectionSettings> = {
  textColor: theme.colors.text.base,
  backgroundColor: theme.colors.brand.quaternary
}

export const pagebuilderSectionDefaultSettings: Partial<PagebuilderSectionSettings> =
  {
    ...defaultMarginSettings,
    ...defaultPaddingSettings,
    ...defaultColorSettings,
    maxContentWidth: theme.dimensions.pageMaxWidth
  }

/**
 * Default settings for specific pagebuilder section types.
 * If a specific section setting is not defined by the CMS, the default value will be used.
 */
export const pagebuilderBaseContentSectionDefaultSettings: Partial<PagebuilderSectionSettings> =
  {
    ...pagebuilderSectionDefaultSettings,
    maxContentWidth: theme.dimensions.pageMaxWidthCondensed
  }

export const pagebuilderNewsletterFormSectionDefaultSettings: Partial<PagebuilderSectionSettings> =
  {
    ...pagebuilderSectionDefaultSettings,
    maxContentWidth: theme.dimensions.pageMaxWidthCondensed
  }

export const pagebuilderMarqueeSectionDefaultSettings: Partial<PagebuilderSectionSettings> =
  {
    ...defaultMarginSettings,
    ...defaultColorSettings,
    spacingDesktopPaddingLeft: 0,
    spacingDesktopPaddingRight: 0,
    spacingDesktopPaddingTop: spacingUnits[4],
    spacingDesktopPaddingBottom: spacingUnits[4],
    spacingTabletPaddingLeft: 0,
    spacingTabletPaddingRight: 0,
    spacingTabletPaddingTop: spacingUnits[4],
    spacingTabletPaddingBottom: spacingUnits[4],
    spacingMobilePaddingLeft: 0,
    spacingMobilePaddingRight: 0,
    spacingMobilePaddingTop: spacingUnits[4],
    spacingMobilePaddingBottom: spacingUnits[4],
    maxContentWidth: PagebuilderMaxContentWidthOptions.full
  }
